import { FASTElement, Updates, customElement, observable } from '@microsoft/fast-element';

import template from './template.js';
import styles from './styles.js';
import { AccordionItem } from '../adaptive-accordion-item/index.js';

@customElement({
	name: 'platform-diagram',
	template,
	styles
})
export class Diagram extends FASTElement {
	@observable
	public svg!: SVGElement;

	@observable
	public items!: AccordionItem[];

	public handleMouseover(index: number): boolean {
		const arm = this.svg.querySelector(`#arm-${index}`)!;

		arm.classList.add('hover');

		return true;
	}

	public handleMouseout(index: number): boolean {
		const arm = this.svg.querySelector(`#arm-${index}`)!;

		arm.classList.remove('hover');
		
		return true;
	}

	public handleExpanded(event: CustomEvent<boolean>, index: number): boolean {
		const arm = this.svg.querySelector(`#arm-${index}`)!;

		if (event.detail) {
			arm.classList.add('active');
		} else {
			arm.classList.remove('active');
		}


		return true;
	}

	public createDiagramHandlers(): void {
		const arms = this.svg.querySelectorAll('[id^="arm-"]');

		arms.forEach(arm => {
			const index = parseInt(arm.id.split('-')[1]) - 1;
			const item = this.items[index];

			arm.addEventListener('mouseover', () => this.handleArmMouseover(arm, item));
			arm.addEventListener('mouseout', () => this.handleArmMouseout(arm, item));
			arm.addEventListener('click', () => this.handleArmClick(item));
		});
	}

	private handleArmMouseover(arm: Element, item: AccordionItem): void {
		arm.classList.add('hover');
		item.classList.add('hover');
	}

	private handleArmMouseout(arm: Element, item: AccordionItem): void {
		arm.classList.remove('hover');
		item.classList.remove('hover');
	}

	private handleArmClick(item: AccordionItem): void {
		item.expanded = !item.expanded;
	}

	public connectedCallback(): void {
		super.connectedCallback();

		
		Updates.enqueue(() => {
			this.svg = this.shadowRoot!.querySelector('svg')!;
			this.createDiagramHandlers();
		});
	}
}